import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Calendar, Mail, Clock, CheckCircle2 } from 'lucide-react';

const CALCOM_URL = process.env.REACT_APP_CALCOM_URL;

const BookDemoModal = ({ open, onOpenChange }) => {

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl max-h-[90vh] overflow-hidden p-0" data-testid="book-demo-modal">
        <DialogHeader className="p-6 pb-2 border-b border-slate-100">
          <DialogTitle className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-emerald-500 bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center shadow-md">
              <Calendar className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="text-lg font-semibold text-slate-900">Book a 15-min FinOps review</p>
              <p className="text-xs text-slate-400 font-normal mt-0.5">
                <Clock className="w-3 h-3 inline mr-1" />
                15 minutes · free · no commitment
              </p>
            </div>
          </DialogTitle>
        </DialogHeader>

        <div className="p-6 overflow-y-auto max-h-[70vh]">
          {CALCOM_URL ? (
            /* Cal.com iframe embed */
            <iframe
              src={CALCOM_URL}
              width="100%"
              height="640"
              frameBorder="0"
              title="Book a 15-min FinOps review"
              className="rounded-xl border border-slate-200"
              data-testid="calcom-embed-iframe"
            />
          ) : (
            /* Friendly fallback when no booking URL is configured yet */
            <div className="text-center py-6 space-y-5" data-testid="book-demo-fallback">
              <div className="w-16 h-16 rounded-2xl bg-emerald-50 flex items-center justify-center mx-auto">
                <Mail className="w-8 h-8 text-emerald-600" />
              </div>
              <div>
                <p className="text-lg font-semibold text-slate-900">Email us for a 15-min review</p>
                <p className="text-sm text-slate-400 mt-2 max-w-md mx-auto">
                  We'll send you 3 time slots within 24 hours. A CARTIEAI founder will walk you through your top 3 cloud-savings opportunities — no slides, no pitch deck.
                </p>
              </div>

              <a
                href="mailto:hello@cartieai.com?subject=Book a 15-min FinOps review&body=Hi CARTIEAI team,%0A%0AI'd like to book a 15-min FinOps review.%0A%0ACompany:%0AMonthly cloud spend (approx):%0ATime zone:%0APreferred days / times:%0A%0AThanks!"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-emerald-500 bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-medium shadow-lg shadow-emerald-500/25 hover:shadow-emerald-500/40 hover:-translate-y-0.5 transition-all"
                data-testid="book-demo-email-btn"
              >
                <Mail className="w-4 h-4" />
                Email hello@cartieai.com
              </a>

              <div className="pt-4 border-t border-slate-100">
                <div className="grid grid-cols-3 gap-3 text-left">
                  {[
                    { label: 'Founder on the call', detail: 'Not a BDR' },
                    { label: 'Zero sales pitch', detail: 'Pure value' },
                    { label: '15 minutes max', detail: 'Respect your time' },
                  ].map((item) => (
                    <div key={item.label} className="flex items-start gap-2">
                      <CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" />
                      <div>
                        <p className="text-xs font-medium text-slate-700">{item.label}</p>
                        <p className="text-[11px] text-slate-400">{item.detail}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="px-6 py-3 border-t border-slate-100 bg-slate-50 flex items-center justify-between">
          <p className="text-xs text-slate-400">
            Prefer async?{' '}
            <a href="mailto:hello@cartieai.com" className="text-emerald-600 hover:underline font-medium">
              hello@cartieai.com
            </a>
          </p>
          <Button variant="ghost" size="sm" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookDemoModal;
